import React from 'react'
import { Link } from 'react-router-dom'
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from 'reactstrap'
import { useGlobalStoreActions, useGlobalStoreData } from '../../store/globalStore'
import { useTranslation } from 'react-i18next'
import McPageHelpers from '../../pages/mc-components/McPageHelpers'
import { useSDSsearchTrigger } from '../../store/searchDataStore'

const Footer = () => {
  const { t } = useTranslation()
  const languageGSD = useGlobalStoreData.language()
  const versionGSD = useGlobalStoreData.version()
  const { setLanguage } = useGlobalStoreActions()
  const searchTrigger = useSDSsearchTrigger()

  const changeLanguage = (e, language) => {
    e.preventDefault()
    setLanguage(language)
  }

  const currentLanguage = McPageHelpers.languageOptions.find((lang) => lang.code === languageGSD)

  return (
    <div className="nk-footer bg-white">
      <div className="container-fluid">
        <div className="nk-footer-wrap">
          <div className="nk-footer-copyright">
            &copy; 2022 - {new Date().getFullYear()} <a href="https://marketcalculus.ai" target="_blank"
                                                        rel="noreferrer">Market
            Calculus</a> {versionGSD}
          </div>
          <div className="nk-footer-links">
            <ul className="nav nav-sm">
              <li className="nav-item">
                <Link to={`${process.env.PUBLIC_URL + '/' + languageGSD}/pages/terms`} className="nav-link">
                  {t('terms')}
                </Link>
              </li>
              <li className={`nav-item ${searchTrigger ? 'disabled-full' : ''}`}>
                <UncontrolledDropdown direction="up">
                  <DropdownToggle
                    color="transparent"
                    className="dropdown-toggle dropdown-indicator has-indicator nav-link"
                  >
                    <span>{currentLanguage?.name || 'Language'}</span>
                  </DropdownToggle>
                  <DropdownMenu end className="dropdown-menu-sm">
                    <ul className="language-list">
                      {McPageHelpers.languageOptions.map(({ code, name, flag }) => (
                        <li key={code}>
                          <DropdownItem
                            tag="a"
                            href="#dropdownitem"
                            onClick={(e) => changeLanguage(e, code)}
                            className="language-item"
                          >
                            <img src={flag} alt="" className="language-flag"/>
                            <span className="language-name">{name}</span>
                          </DropdownItem>
                        </li>
                      ))}
                    </ul>
                  </DropdownMenu>
                </UncontrolledDropdown>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  )
}
export default Footer
